import { actionTypes } from '../../../controller';
import jwt from '../../../../lib/jwt';

const {
	START_FORCE_CONNECT_SOCKET,
	START_FORCE_DISCONNECT_SOCKET,
	RUN_FORCE_RECONNECTING_SOCKET_STEP_ONE_DISCONNECT,
	RUN_FORCE_RECONNECTING_SOCKET_STEP_TWO_CONNECT,
} = actionTypes;

export function forceConnectSocketEmitter(socket) {
	return function (store, action) {
		const { type } = action;

		if (type === START_FORCE_CONNECT_SOCKET) {
			socket.io.opts.query = { token: jwt.current };
			socket.connect();
		}
	};
}

export function forceDisconnectSocketEmitter(socket) {
	return function (store, action) {
		const { type } = action;

		if (type === START_FORCE_DISCONNECT_SOCKET) {
			socket.disconnect();
		}
	};
}

export function forceReconnectSocketEmitter(socket) {
	return function (store, action) {
		const { type } = action;

		if (type === RUN_FORCE_RECONNECTING_SOCKET_STEP_ONE_DISCONNECT) {
			queueMicrotask(() => socket.disconnect());
			return;
		}

		if (type === RUN_FORCE_RECONNECTING_SOCKET_STEP_TWO_CONNECT) {
			socket.io.opts.query = { token: jwt.current };
			socket.connect();
		}
	};
}
